import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import * as Application from "expo-application";
import {
	Box,
	Divider,
	Heading,
	useMediaQuery,
	VStack,
	Text,
	Icon,
	Stack,
	useTheme,
	Button,
	HStack,
} from "native-base";
import React from "react";
import { Dimensions, FlatList, ScrollView, View } from "react-native";
import { useSelector } from "react-redux";
import MemberContentArea from "../../components/MemberContentArea";
import TableRow from "../../components/TableRow";

const Profile = ({ navigation, route }) => {
	const { colors } = useTheme();
	const { width, height } = Dimensions.get("window");
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 })[0];
	const Auth = useSelector((state) => state.Login.Auth);
	const { profile } = Auth;
	// console.log("profile", profile);
	let { balance, data, role, stores } = profile;
	// console.log(stores);
	let storeString = "";
	stores.map((store) => {
		storeString += `[ ${store.store_name} ] `;
	});
	// console.log(stores);
	const show = [
		"email_address",
		// "first_name",
		"gender",
		"id_passport_number",
		"mobile_number",
		// "second_name",
		"username",
	];
	const filteredData = data.filter((item) => show.includes(item.type_name));
	let profileData = [];
	profileData.push({ name: "Stores", value: storeString });
	// profileData.push({ name: "Role", value: role });
	filteredData.map((item) => {
		profileData.push({ name: item.type_lable, value: item.data_text });
	});
	// console.log("Filter", profileData);
	return (
		<ScrollView>
			<Box>
				<Box
					border="1"
					borderRadius="md"
					style={{
						flex: 1,
						marginTop: isDesktopOrLaptop ? 0 : 5,
						marginHorizontal: 5,
					}}
				>
					<Stack space="2" direction={isDesktopOrLaptop ? "row" : "column"}>
						<Box
							px="4"
							p={isDesktopOrLaptop ? "5" : "4"}
							marginX={isDesktopOrLaptop ? 2 : 0}
							bg="#fff"
							borderRadius="10"
							// justifyContent="center"
							style={{
								shadowOffset: { width: 0.5, height: 0.2 },
								shadowOpacity: 0.7,
								shadowRadius: 1,
								shadowColor: "#d5d5d5",
							}}
						>
							<Box
								px="2"
								alignItems="center"
								flexDirection={isDesktopOrLaptop ? "column" : "row"}
							>
								<View
									style={{
										backgroundColor: "#d5d5d5",
										padding: 20,
										borderRadius: 60,
										marginBottom: 5,
									}}
								>
									<Icon as={Ionicons} name="person-outline" size="xl" />
								</View>
								<VStack
									space={4}
									style={{ marginLeft: isDesktopOrLaptop ? 0 : 20 }}
								>
									<View
										style={
											isDesktopOrLaptop
												? {
														alignItems: "center",
												  }
												: {}
										}
									>
										<Text fontSize="18" fontWeight="900" color="gray.700">
											{`${
												Auth.profile.data.filter(
													(profile) => profile.type_name === "first_name"
												)[0]?.data_text
											} ${
												Auth.profile.data.filter(
													(profile) => profile.type_name === "second_name"
												)[0]?.data_text
											}`}
										</Text>
										<Text
											style={{ top: -7 }}
											fontSize="14"
											mt="1"
											color="gray.500"
											fontWeight="500"
										>
											{Auth.profile.role}
										</Text>
									</View>
									{/* <Button
										isDisabled={true}
										variant="outline"
										leftIcon={<Icon as={MaterialIcons} name="edit" size="sm" />}
									>
										Edit Profile
									</Button> */}
								</VStack>
							</Box>
						</Box>
						<Box
							px="2"
							p="4"
							style={{
								flex: 1,
								shadowOffset: { width: 0.5, height: 0.2 },
								shadowOpacity: 0.7,
								shadowRadius: 1,
								shadowColor: "#d5d5d5",
							}}
							bg="rgb(253, 253, 253)"
							borderRadius="10"
						>
							<Box p="2" bg={colors.primary["500"]} borderRadius="5">
								<Heading fontWeight="900" size="xs" color="#fff">
									Personal Details
								</Heading>
							</Box>
							<FlatList
								data={profileData}
								renderItem={({ item }) => {
									return (
										<Box>
											<TableRow value={item.value} title={item.name} />
										</Box>
									);
								}}
								keyExtractor={(item) => item.name}
								ListFooterComponent={
									<>
										{!isDesktopOrLaptop && (
											<>
												<Box p="2" bg={colors.primary["500"]} borderRadius="5">
													<Heading fontWeight="900" size="xs" color="#fff">
														App Settings
													</Heading>
												</Box>
												<Box>
													<TableRow
														title="App Version"
														value={Application.nativeApplicationVersion}
													/>
													<TableRow
														title="Application Name"
														value={Application.applicationName}
													/>
												</Box>
											</>
										)}
									</>
								}
							/>
						</Box>
					</Stack>
				</Box>
			</Box>
		</ScrollView>
	);
};
export default Profile;
